@if (affiliation?.data.title || affiliation?.data.position) {
  {{ affiliationService.getTranslatedPositionOrTitle(affiliation?.data) }},
}

<!-- internal affiliation -->
@if (affiliation?.ancestors.length > 0) {
  @for (ancestor of affiliation?.ancestors; track ancestor; let last = $last) {
    <span>
      {{ ancestor.organizationCode | defaultTranslate: { default: ancestor.organizationName }
      }}@if (!last) {
      ,
    }
  </span>
}
}

<!-- external affiliation -->
@if (affiliation?.ancestors.length === 0) {
  <span>
    {{ affiliation?.data.organizationCode | defaultTranslate: { default: affiliation?.data.organizationName } }}
  </span>
}
